import styled from 'styled-components';

export const StyledRecordCourseVideoTable = styled.div`
  /* Code Here */
`;